/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Computer_Science15Inputs */

const en_job_form_enum_computer_science15 = /** @type {(inputs: Job_Form_Enum_Computer_Science15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer Science`)
};

const de_job_form_enum_computer_science15 = /** @type {(inputs: Job_Form_Enum_Computer_Science15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik`)
};

/**
* | output |
* | --- |
* | "Computer Science" |
*
* @param {Job_Form_Enum_Computer_Science15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_computer_science15 = /** @type {((inputs?: Job_Form_Enum_Computer_Science15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Computer_Science15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_computer_science15(inputs)
	return en_job_form_enum_computer_science15(inputs)
});
export { job_form_enum_computer_science15 as "job_form_enum_COMPUTER_SCIENCE" }